// exportCommitHooks.js
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  queueDownloadExportCommit,
  startDownloadExportCommit,
  downloadingExportCommit,
  statusUpdateExportCommit,
  reset,
} from "./index";

/**
 * Hook for export commit management functionality
 */
export const useExportCommit = () => {
  const dispatch = useDispatch();
  const exportCommitState = useSelector((state) => state.exportCommit);

  // Mark the export commit as downloading
  const handleDownloadingExportCommit = useCallback(() => {
    dispatch(downloadingExportCommit());
  }, [dispatch]);

  // Queue a download for the export commit
  const handleQueueDownloadExportCommit = useCallback(
    (caseId, clipId) => {
      return dispatch(queueDownloadExportCommit({ caseId, clipId }));
    },
    [dispatch],
  );

  // Reset the export commit state
  const handleResetExportCommit = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  // Start the export commit download
  const handleStartDownloadExportCommit = useCallback(() => {
    dispatch(startDownloadExportCommit());
  }, [dispatch]);

  // Update the export commit status
  const handleStatusUpdateExportCommit = useCallback(
    (status, guid, percentComplete) => {
      dispatch(statusUpdateExportCommit({ status, guid, percentComplete }));
    },
    [dispatch],
  );

  return {
    // State
    exportStatus: exportCommitState.exportStatus,
    fileCount: exportCommitState.fileCount,
    totalBytes: exportCommitState.totalBytes,
    guid: exportCommitState.guid,
    isDownloadReady: exportCommitState.isDownloadReady,
    isDownloading: exportCommitState.isDownloading,
    isExported: exportCommitState.isExported,
    isExporting: exportCommitState.isExporting,
    percentComplete: exportCommitState.percentComplete,

    // Actions
    downloadingExportCommit: handleDownloadingExportCommit,
    queueDownloadExportCommit: handleQueueDownloadExportCommit,
    reset: handleResetExportCommit,
    startDownloadExportCommit: handleStartDownloadExportCommit,
    statusUpdateExportCommit: handleStatusUpdateExportCommit,
  };
};
